import { render } from "./UniqueKeyMessageConfirmPage.vue?vue&type=template&id=21f988d8&scoped=true"
import script from "./UniqueKeyMessageConfirmPage.vue?vue&type=script&lang=js"
export * from "./UniqueKeyMessageConfirmPage.vue?vue&type=script&lang=js"

import "./UniqueKeyMessageConfirmPage.vue?vue&type=style&index=0&id=21f988d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f988d8"]])

export default __exports__